import styled from 'styled-components'

export const PanelBody = styled.div`
  padding: 18px 36px 50px 36px;
`

export const DialogContent = styled.div`
  padding: 0 0 60px 0;
`
